<template>
  <div>
    <div class="row">
      <b-button href="/adm/metas/" variant="primary" size="sm" class="mr-2"
        ><i class="fa fa-tasks"></i> Visualizar Metas</b-button
      >
      <b-button variant="primary" size="sm" class="mr-2" href="/adm/metas/graph"
        ><i class="fas fa-chart-bar"></i> Ver Indicadores</b-button
      >
      <!-- <b-button href="#" @click="addBonifica" variant="primary" class="mr-2" size="sm"> Gerar Pedido Bonificação</b-button> -->
    </div>
    <h3 class="mt-3">Pedidos Bonificados</h3>
    <b-card class="mt-1">
      <b-row class="mb-3">
        <b-col lg="4">
          <b-form-group label-for="filter-input" label-size="sm" class="mb-0">
            <b-input-group>
              <b-form-input
                size="sm"
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Buscar Distribuidor"
              ></b-form-input>
              <b-input-group-append>
                <b-button size="sm" :disabled="!filter" @click="filter = ''"
                  >Limpar</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button variant="primary" size="sm" @click="getPedidoB()"
            >Buscar</b-button
          >
        </b-col>
      </b-row>
      <b-table
        :busy="loading"
        class="mt-1"
        :items="pedidos"
        :fields="fields"
        stacked="md"
        show-empty
        hover
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        :sort-direction="sortDirection"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Buscando...</strong>
          </div>
        </template>
        <template #cell(aprovado)="row">
          <b-button
            variant="success"
            size="sm"
            disabled
            v-if="row.value"
            title="Bonificação Aprovada"
            ><i class="fas fa-check"></i> Bonificação Aprovada</b-button
          >
          <b-button
            variant="warning"
            size="sm"
            v-if="!row.value"
            title="Aguardando Aprovação"
            @click="setAprova(row.item.id)"
            ><i class="fas fa-exclamation"></i> Aprovar
          </b-button>
          <b-button
            variant="danger"
            title="Deletar Bonificação"
            @click="Deletar(row.item.id)"
            ><i class="fas fa-trash"></i>
          </b-button>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="fill"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>

    <!---------------- MODAL PARA INCLUIR UMA NOVA META ------------------------>
    <b-modal v-model="modalBonifica" title="Gerar Bonificação">
      <b-card>
        <b-card-body>
          <ul class="text-danger">
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
          <div class="row">
            <div class="col-md-12">
              <label for="distribuidor">Selecione o Distribuidor:</label>
              <v-select
                id="distribuidor"
                v-model="distribuidor"
                :options="listaDistribuidor"
                :disabled="!showDistribuidor"
                :onSearch="loadDistribuidor"
              ></v-select>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <label for="dataExp">Data de Expiração da Bonificação</label>
              <date-picker
                id="dataExp"
                v-model="data_expira"
                :config="datePickerConfig"
              ></date-picker>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-12">
              <label for="valorBon">Valor R$ - </label
              ><small> Informe o valor da bonificação:</small>
              <input
                id="valorBon"
                class="form-control"
                v-model="valor"
                type="text"
                v-mask="[
                  '#.##',
                  '##.##',
                  '###.##',
                  '####.##',
                  '#####.##',
                  '######.##',
                ]"
              />
            </div>
          </div>
        </b-card-body>
      </b-card>
      <template #modal-footer>
        <div v-if="bonificacao_id > 0">
          <button
            type="button"
            @click="Deletar(bonificacao_id)"
            class="btn btn-block"
            data-dismiss="modal"
          >
            <span class="fas fa-trash"></span> Deletar
          </button>
        </div>
        <br />
        <b-button @click="Salvar" :href="'#'" variant="primary" size="sm"
          ><i class="fa fa-save"></i> Salvar</b-button
        >
        <b-button variant="danger" @click="modalBonifica = false" size="sm"
          >Cancelar</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      datePickerConfig: {
        format: "DD/MM/YYYY",
        showClose: true,
      },
      search: "",
      data: [],
      status: null,
      distribuidor: null,
      listaDistribuidor: [],
      listCampanhas: [],
      campanha: "",
      meta_id: 0,
      dataMeta: "",
      listaMeta: [],
      nomedistribuidor: "",
      showDistribuidor: true,
      errors: [],
      modalBonifica: false,
      fields: [
        {
          key: "data_expira",
          label: "Expira em",
          class: "text-center",
          filterByFormatted: true,
          sortable: true,
          formatter: (value) => {
            return moment(value).format("DD/MM/YYYY");
          },
        },
        {
          key: "distribuidor",
          label: "Distribuidor",
          sortField: "codigo",
          class: "text-center",
          sortable: true,
          formatter: (value) => {
            return value ? value.codigo + "  -  " + value.nome : "";
          },
        },
        {
          key: "valor",
          label: "Limite Crédito ",
          class: "text-center",
          formatter: (value) => {
            return value ? "R$ " + value : "";
          },
        },
        {
          key: "aprovado",
          label: "Status",
          sortable: true,
          class: "text-center",
          // sortByFormatted: true,
        },
      ],
      sortBy: "data_expira",
      sortDesc: true,
      sortDirection: "asc",
      pedidos: [],
      data_expira: "",
      valor: 0.0,
      bonificacao_id: 0,
      moreParams: {},
      isBusy: false,
      aprovar: null,
      loading: false,
    };
  },

  methods: {
    onFiltered(distribuidor) {
      this.totalRows = distribuidor.length;
      this.currentPage = 1;
    },
    getPedidoB() {
      const vm = this;
      this.loading = true;
      axios
        .get("/adm/bonificacao/show")
        .then(function (response) {
          vm.pedidos = response.data.data;
          vm.aprovar = response.data.data.aprovado;
          vm.totalRows = response.data.data.length;
          vm.currentPage = 1;
        })
        .catch(function (e) {
          console.log(e);
        })
        .finally(() => {
          vm.loading = false;
        });
    },

    addBonifica() {
      this.distribuidor = null;
      (this.valor = 0), this.getCampanhas();
      this.modalBonifica = true;
    },
    initData() {
      let m = moment();
      m.set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      });

      this.data_expira = moment();
      this.data_expira.set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      });
    },

    valida() {
      if (this.distribuidor == null) {
        this.$swal("Ops", "Por favor, selecione um distribuidor", "error");
        return false;
      } else if (this.valor <= 0) {
        this.$swal(
          "Ops",
          "Por favor, informe o valor da bonificação.",
          "error"
        );
        return false;
      }
      return true;
    },
    Salvar() {
      if (!this.valida()) {
        return;
      }
      $(".loading").show();
      var data = {
        distribuidor: this.distribuidor.value,
        valor: this.valor,
        data_expira: this.data_expira,
        campanha: this.campanha.value,
        bonificacao_id: this.meta_id,
      };
      console.log(data);
      var vm = this;
      axios
        .post("/adm/bonificacao/salva", data)
        .then(function (response) {
          $(".loading").hide();
          vm.$swal("Ok", response.data.success, "success");
          vm.meta_id = response.data.id ? response.data.id : 0;
          vm.initData();
          vm.getPedidoB();
          vm.modalBonifica = false;
        })
        .catch(function (error) {
          $(".loading").hide();
          var e = error.response.data.errors;
          vm.$swal("Ops", error.response ? e : `${error}`, "error");
        });
    },
    Deletar(id) {
      var data = {
        bonificacao_id: id,
      };
      var vm = this;
      this.$swal
        .fire({
          title: "Realmente deseja deletar esta bonificação ?",
          text: "Esta ação não poderá ser revertida!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, Deletar!",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.value) {
            $(".loading").show();
            axios
              .post("/adm/bonificacao/delete", data)
              .then(function (response) {
                $(".loading").hide();
                vm.$swal("Ok!", response.data.success, "success");
                vm.initData();
                vm.getPedidoB();
              })
              .catch(function (error) {
                $(".loading").hide();
                var e = error.response.data.errors;
                vm.$swal("Erro", error.response ? e : `${error}`, "error");
              });
          }
        });
      $(".loading").hide();
    },

    getCampanhas() {
      var vm = this;
      $(".loading").show();
      vm.listCampanhas = [];
      axios
        .get("/adm/campanhas/list")
        .then(function (response) {
          var obj = response.data;
          obj.forEach(function (x) {
            vm.listCampanhas.push({
              value: x.id,
              label: x.codigo,
            });
          });

          $(".loading").hide();
        })
        .catch(function (error) {
          console.log(error);
          $(".loading").hide();
        });
    },
    loadDistribuidor(key) {
      var vm = this;
      this.listaDistribuidor = [];
      axios
        .get("/adm/distribuidores/combo", {
          params: {
            query: key,
          },
        })
        .then(function (response) {
          console.log(response.data);
          var obj = response.data;
          obj.forEach(function (v) {
            vm.listaDistribuidor.push({
              value: v.id,
              label: v.codigo + " - " + v.nome,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    setAprova(id) {
      var vm = this;
      this.$swal
        .fire({
          title: "Deseja aprovar esta bonificação?",
          text: "Ao aprovar, o sistema irá gerar um link possibilitando a digitação do pedido.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim Aprovar",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.value) {
            $(".loading").show();
            axios
              .post("/adm/bonificacao/aprova", {
                bonificacao_id: id,
              })
              .then(function (response) {
                console.log(response.data);
                var obj = response.data;
                vm.$swal.fire("Ok!", obj.success, "success");
                vm.getPedidoB();
                $(".loading").hide();
              })
              .catch(function (error) {
                $(".loading").hide();
                var e = error.response.data;
                vm.$swal.fire(
                  "Ops!",
                  error.response ? e.errors : `${error}`,
                  "error"
                );
                console.log(error);
              });
          }
        });
    },
  },

  mounted() {
    this.initData();
    this.getPedidoB();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pedidos/Bonificados.vue